import React from "react";
import Header from "../components/header";
import DashboardIndex from "../components/dashboard/dashboardIndex";
function DashboardAbogados() {
  return (
    <div>
      <div className="indexpage">
        <Header />
        <DashboardIndex />
      </div>
    </div>
  );
}

export default DashboardAbogados;
